// Checkout submission: validates the shipping form, toggles the demo bank
// info block, and places the order via admin-ajax (no real backend existed
// for checkout before this — see openspec/changes/checkout-order-flow).
import { getCart, clearCart } from './cart.js';

const REQUIRED_FIELDS = [
	{ name: 'checkout_name', label: 'Họ tên' },
	{ name: 'checkout_phone', label: 'Số điện thoại' },
	{ name: 'checkout_email', label: 'Email' },
	{ name: 'checkout_address', label: 'Địa chỉ' },
	{ name: 'checkout_province', label: 'Tỉnh/Thành phố' },
	{ name: 'checkout_ward', label: 'Phường/Xã' },
];

function isValidEmail(value) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

// Vietnamese mobile numbers: 0 or +84, then a valid carrier-prefix second
// digit, then 7 more digits (10 digits total when starting with 0).
const PHONE_PATTERN = /^(0|\+84)(3[2-9]|5[25689]|7[06-9]|8[1-9]|9[0-46-9])[0-9]{7}$/;

function isValidPhone(value) {
	return PHONE_PATTERN.test(value.replace(/[\s.-]/g, ''));
}

function showError(errorEl, message) {
	errorEl.textContent = message;
	errorEl.hidden = false;
}

function clearError(errorEl) {
	errorEl.hidden = true;
	errorEl.textContent = '';
}

// The tỉnh/thành phố and phường/xã selects store the address dataset's
// `code` as their value (used only for the cascade lookup in
// address-cascade.js); the human-readable name is the option's own text.
// Orders need the name for storage/display, not the code.
function selectedOptionText(select) {
	return select.options[select.selectedIndex]?.text || '';
}

function validateForm(form, errorEl) {
	const missing = REQUIRED_FIELDS
		.filter(({ name }) => !form.elements[name].value.trim())
		.map(({ label }) => label);

	if (missing.length) {
		showError(errorEl, `Vui lòng điền: ${missing.join(', ')}`);
		return false;
	}

	if (!isValidPhone(form.elements.checkout_phone.value.trim())) {
		showError(errorEl, 'Số điện thoại không hợp lệ.');
		return false;
	}

	if (!isValidEmail(form.elements.checkout_email.value.trim())) {
		showError(errorEl, 'Email không hợp lệ.');
		return false;
	}

	return true;
}

document.addEventListener('DOMContentLoaded', () => {
	const form = document.getElementById('checkout-form');
	if (!form) {
		return;
	}

	const errorEl = document.getElementById('checkout-form-error');
	const bankInfoEl = document.getElementById('checkout-bank-info');

	document.querySelectorAll('input[name="payment_method"]').forEach((radio) => {
		radio.addEventListener('change', () => {
			if (bankInfoEl) {
				bankInfoEl.hidden = radio.value !== 'bank_transfer' || !radio.checked;
			}
		});
	});

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		clearError(errorEl);

		if (!validateForm(form, errorEl)) {
			return;
		}

		const cart = getCart();
		if (!cart.length) {
			showError(errorEl, 'Giỏ hàng của bạn đang trống.');
			return;
		}

		const paymentMethodInput = document.querySelector('input[name="payment_method"]:checked');
		const submitButton = form.querySelector('button[type="submit"]');
		const originalLabel = submitButton.textContent;
		submitButton.disabled = true;
		submitButton.innerHTML = '<span class="btn__spinner" aria-hidden="true"></span>Đang xử lý...';

		const body = new URLSearchParams({
			action: 'hgtheme_place_order',
			nonce: window.hgthemeData.checkoutNonce,
			name: form.elements.checkout_name.value.trim(),
			phone: form.elements.checkout_phone.value.trim(),
			email: form.elements.checkout_email.value.trim(),
			address: form.elements.checkout_address.value.trim(),
			province: selectedOptionText(form.elements.checkout_province),
			ward: selectedOptionText(form.elements.checkout_ward),
			note: form.elements.checkout_note.value.trim(),
			payment_method: paymentMethodInput ? paymentMethodInput.value : 'cod',
			items: JSON.stringify(cart),
		});

		fetch(window.hgthemeData.ajaxUrl, { method: 'POST', body })
			.then((res) => res.json())
			.then((data) => {
				if (data.success) {
					clearCart();
					window.location.href = `/cam-on/?order=${data.data.order_id}&token=${data.data.token}`;
					return;
				}
				showError(errorEl, data.data?.message || 'Có lỗi xảy ra, vui lòng thử lại.');
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;
			})
			.catch(() => {
				showError(errorEl, 'Có lỗi xảy ra, vui lòng thử lại.');
				submitButton.disabled = false;
				submitButton.textContent = originalLabel;
			});
	});
});
